import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ENewQuestionModalStep } from '../../types/newQuestion';

export enum EStepActionTypes {
  Set = 'NEW_QUESTION/STEP/SET',
}

export type TSetStep = ITypedReduxAction<EStepActionTypes.Set, ENewQuestionModalStep>;

export type TNewQuestionFormStepActions = TSetStep;

/**
 * Redux action, который вызывает устанавливает шаг формы
 */
export const setNewQuestionFormStep: (step: ENewQuestionModalStep) => TSetStep = actionGenerator<
  EStepActionTypes.Set,
  ENewQuestionModalStep
>(EStepActionTypes.Set);
